import { Pane, Switch } from 'evergreen-ui';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { updateSettings } from '../../../queries/settings';
import { setSettings } from '../../../store/settingsSlice';

const StyledToggle = styled.div`
  background: #2b2d2e;
  border-radius: 16px;
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > label > input:not([disabled]) + div {
    background-color: #525353 !important;
  }
  & > label > input:checked + div {
    background-color: #e78850 !important;
  }

  * {
    outline: none;
  }
`;

const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const StyledDayToggle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px;
  width: 72px;
  height: 72px;
  border-radius: 16px;
  background: #2b2d2e;
  color: #ffffff;
  &.active {
    background: #e78850;
  }
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
  &.loading {
    opacity: 0.5;
    &:hover {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

const PanelWorkingDays = ({ settings, enabled }) => {
  const dispatch = useDispatch();
  const { dayFilters } = settings;
  const [dfs, setDfs] = useState(
    dayFilters.map(({ day, start, end, rejectAll }) => ({
      day,
      start,
      end,
      rejectAll,
    })),
  );
  const [checked, setChecked] = useState(dayFilters?.every(f => !f.rejectAll));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDfs(
      dayFilters.map(({ day, start, end, rejectAll }) => ({
        day,
        start,
        end,
        rejectAll,
      })),
    );
    setChecked(dayFilters?.every(f => !f.rejectAll));
  }, [dayFilters]);

  const token = useSelector(state => state.authentication.token);

  const updateSettingsQuery = useMutation(updateSettings, {
    useErrorBoundary: true,
  });
  const updateDayFilters = async df => {
    setLoading(true);
    await updateSettingsQuery.mutateAsync({
      dayFilters: df,
      enabled,
      token,
    });
    dispatch(
      setSettings({
        ...settings,
        dayFilters: df,
      }),
    );

    dispatch(setSettings({ ...settings, dayFilters: df }));
    setLoading(false);
  };

  const onChange = () => {
    if (!checked) {
      var updatedDayFilters = [];
      dfs.forEach(({ day, start, end }) => {
        updatedDayFilters.push({ day, start, end, rejectAll: false });
      });
      setDfs(updatedDayFilters);
      updateDayFilters(updatedDayFilters);
    }
    setChecked(!checked);
  };
  const toggleDay = d => () => {
    var updatedDayFilters = [];
    dfs.forEach(({ day, start, end, rejectAll }, key) => {
      if (d === key) {
        updatedDayFilters.push({ day, start, end, rejectAll: !rejectAll });
      } else {
        updatedDayFilters.push({ day, start, end, rejectAll });
      }
    });
    setDfs(updatedDayFilters);
    updateDayFilters(updatedDayFilters);
  };

  const activeDays = dfs?.map(df => !df.rejectAll);

  return (
    <Pane
      background="#1F2021"
      position="relative"
      display="flex"
      flex={1}
      height="100%"
      paddingX={25}
      paddingTop={15}
      paddingBottom={30}
      flexDirection="column"
    >
      <h2 style={{ color: 'white', fontSize: 18, marginBottom: 0 }}>Select working days</h2>
      <p style={{ color: '#A7AAAC' }}>Select the days of the week for which you would like to accept offers for</p>

      <StyledToggle>
        <p style={{ color: '#FFFFFF', fontSize: 16, fontWeight: 500 }}>All days</p>
        <Switch height={30} checked={checked} onChange={onChange} disabled={loading} />
      </StyledToggle>

      {!checked && (
        <Pane marginTop={30} display="flex" flexDirection="column" alignItems="center">
          <p style={{ color: '#A7AAAC', fontSize: 12 }}>Days marked in Orange are days you want to work</p>
          <Pane display="flex" flexWrap="wrap" justifyContent="center">
            {activeDays &&
              weekDays.map((d, key) => (
                <StyledDayToggle
                  key={key}
                  className={`${activeDays[key] ? 'active' : ''} ${loading ? 'loading' : ''}`}
                  onClick={loading ? () => {} : toggleDay(key)}
                >
                  {d}
                </StyledDayToggle>
              ))}
          </Pane>
        </Pane>
      )}
    </Pane>
  );
};

export default PanelWorkingDays;
